import { defineComponent } from '@nuxtjs/composition-api';
import CommissionBalanceQuery from '@/apollo/queries/CommissionBalance.query';
import CommissionTransactionsSubscription from '@/apollo/subscriptions/CommissionTransactions.subscription';
import type { CommissionBalance } from '@/types/graphql';

type Subscription = {
  unsubscribe: () => void;
};

export default defineComponent({
  apollo: {
    commissionBalance: {
      query: CommissionBalanceQuery,
      skip() {
        return !this.$auth.loggedIn;
      },
    },
  },
  data(): { commissionBalance: CommissionBalance | null; subscription: Subscription | null } {
    return {
      commissionBalance: null,
      subscription: null,
    };
  },
  methods: {
    subscribe() {
      this.subscription = this.$apollo.queries.commissionBalance.subscribeToMore({
        document: CommissionTransactionsSubscription,
        updateQuery: (previous = {}, { subscriptionData: { data: next } }) => {
          return {
            ...previous,
            commissionBalance: {
              ...previous?.commissionBalance,
              ...next?.commissionTransactions?.commissionChange,
            },
          };
        },
      }) as unknown as Subscription;
    },
    unsubscribe() {
      this.subscription?.unsubscribe();
    },
  },
});
